import React, { Component } from 'react';
import FlagIconFactory from 'react-flag-icon-css';
const FlagIcon = FlagIconFactory(React, { useCssModules: false });

export default class TopCountries extends Component {
  constructor(props) {
    super(props);
    this.each = this.each.bind(this);
  }
  
  each(item, index) {
    if (item.country === 'NOT_FOUND') return false;
    var className = "";
    if (index < 5) {
      className = "w-40 mr3 pv3 br-ns center b--white-40 w-20-ns w4-l";
    } else if (index < 8) {
      /* From here countries are shown only in large displays */
      className = "dn db-l w-40 mr3 pv3 br-ns center b--white-40 w-20-ns w4-l";
    } else {
      /* From here countries are shown only in x-large displays */
      className = "dn db-xl w-40 mr3 pv3 br-ns center b--white-40 w-30-ns w4-l";
    }
    if (index >= 12) return false;
    return (
      <div key={ 'country_total_' + item.country } className={ className }>
        <div className="flex justify-center items-center mb2">
          <FlagIcon code={ item.flag } />
          <p className="pl2 ttu fw1 f4 mv0 mr3">{ item.country }</p>
        </div>
        <div className="tc">
          <p className="f3 fw6 mv0">{ item.count.withSeparator('.') }</p>
        </div>
      </div>
    );
  }
  render() {
    return (
        <div>
            {
                this.props.loaded
                ? (<div className="flex-l">
                        <h3 className="mv0 f3 fw1 tc pb3 w4-l tl-l self-center-l"> Top Countries</h3>
                        <div className="flex flex-wrap flex-row-m justify-between justify-around-xl w-100-l">
                            { this.props.data.map(this.each) }
                        </div>
                    </div>)
                : ''
            }
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/TopCountries/index.js